var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoicingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.998,
    height: 20,
    viewBox: "0 0 14.998 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_receipt",
    "data-name": "solid receipt",
    d: "M14,.1l-1.5,1.75L10.374.1a.621.621,0,0,0-.75,0L7.5,1.849,5.374.1a.621.621,0,0,0-.75,0L2.5,1.849,1,.1A.625.625,0,0,0,0,.6V19.347a.625.625,0,0,0,1,.5L2.5,18.1l2.125,1.75a.621.621,0,0,0,.75,0L7.5,18.1l2.125,1.75a.621.621,0,0,0,.75,0L12.5,18.1l1.5,1.75a.625.625,0,0,0,1-.5V.6A.625.625,0,0,0,14,.1ZM12.5,14.035a.313.313,0,0,1-.312.312H2.812a.313.313,0,0,1-.312-.312V13.41a.313.313,0,0,1,.312-.312h9.374a.313.313,0,0,1,.312.312Zm0-3.75a.313.313,0,0,1-.312.312H2.812a.313.313,0,0,1-.312-.312V9.661a.313.313,0,0,1,.312-.312h9.374a.313.313,0,0,1,.312.312Zm0-3.75a.313.313,0,0,1-.312.312H2.812A.313.313,0,0,1,2.5,6.536V5.911A.313.313,0,0,1,2.812,5.6h9.374a.313.313,0,0,1,.312.312Z",
    transform: "translate(0 0.027)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicingIcon);
export default __webpack_public_path__ + "static/media/invoicing-icon.6735e7818202ba9a5c7f1b77cf44814c.svg";
export { ForwardRef as ReactComponent };